export default __webpack_public_path__ + "static/media/Gellix-Regular.8e7d54ec.woff2";